import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  changePassword: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
};

export const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: INITIAL_STATE,
  reducers: {
    putChangePassword: (state) => {
      state.changePassword.isLoading = true;
    },
    putChangePasswordSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      changePassword: {
        ...state.changePassword,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    putChangePasswordFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      changePassword: {
        ...state.changePassword,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  putChangePassword,
  putChangePasswordSuccess,
  putChangePasswordFailure,
} = changePasswordSlice.actions;
export const changePasswordReducer = changePasswordSlice.reducer;
